//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiBase } from "./AuthorizedApiBase";
import { ApiConfig } from './ApiConfig';import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class UserClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    admin(body?: UpdateUserRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    allUsers(  cancelToken?: CancelToken | undefined): Promise<GetAllUsersResponse[]> {
        let url_ = this.baseUrl + "/allUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllUsers(_response);
        });
    }

    protected processAllUsers(response: AxiosResponse): Promise<GetAllUsersResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllUsersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllUsersResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllUsersResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    user(body?: DeleteUserRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUser(_response);
        });
    }

    protected processUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    currentUser(  cancelToken?: CancelToken | undefined): Promise<GetCurrentUserResponse> {
        let url_ = this.baseUrl + "/currentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrentUser(_response);
        });
    }

    protected processCurrentUser(response: AxiosResponse): Promise<GetCurrentUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentUserResponse.fromJS(resultData200);
            return Promise.resolve<GetCurrentUserResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    currentUserRole(  cancelToken?: CancelToken | undefined): Promise<GetCurrentUserRoleResponse> {
        let url_ = this.baseUrl + "/currentUserRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrentUserRole(_response);
        });
    }

    protected processCurrentUserRole(response: AxiosResponse): Promise<GetCurrentUserRoleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentUserRoleResponse.fromJS(resultData200);
            return Promise.resolve<GetCurrentUserRoleResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentUserRoleResponse>(null as any);
    }

    /**
     * @return Success
     */
    organsation(  cancelToken?: CancelToken | undefined): Promise<UserResponse[]> {
        let url_ = this.baseUrl + "/organsation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrgansation(_response);
        });
    }

    protected processOrgansation(response: AxiosResponse): Promise<UserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    organsationInvite(body?: UserResponse | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/organsation-invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrgansationInvite(_response);
        });
    }

    protected processOrgansationInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    organsationWithRole(  cancelToken?: CancelToken | undefined): Promise<UserRoleResponse[]> {
        let url_ = this.baseUrl + "/organsationWithRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrgansationWithRole(_response);
        });
    }

    protected processOrgansationWithRole(response: AxiosResponse): Promise<UserRoleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserRoleResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRoleResponse[]>(null as any);
    }

    /**
     * @param organisationId (optional) 
     * @return Success
     */
    organsationWithRoleByOrganisationId(organisationId?: string | undefined , cancelToken?: CancelToken | undefined): Promise<UserRoleResponse[]> {
        let url_ = this.baseUrl + "/organsationWithRoleByOrganisationId?";
        if (organisationId === null)
            throw new Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrgansationWithRoleByOrganisationId(_response);
        });
    }

    protected processOrgansationWithRoleByOrganisationId(response: AxiosResponse): Promise<UserRoleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserRoleResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRoleResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    partner(  cancelToken?: CancelToken | undefined): Promise<UserResponse[]> {
        let url_ = this.baseUrl + "/partner";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartner(_response);
        });
    }

    protected processPartner(response: AxiosResponse): Promise<UserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerInvite(body?: UserResponse | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/partner-invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerInvite(_response);
        });
    }

    protected processPartnerInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserName(body?: UpdateUserNameRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/updateUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserName(_response);
        });
    }

    protected processUpdateUserName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AttachmentClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    download(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment/download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CaseClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    caseGet(  cancelToken?: CancelToken | undefined): Promise<CaseResponse[]> {
        let url_ = this.baseUrl + "/api/Case";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseGet(_response);
        });
    }

    protected processCaseGet(response: AxiosResponse): Promise<CaseResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    casePost(body?: CreateCaseRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCasePost(_response);
        });
    }

    protected processCasePost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    casePut(body?: UpdateCaseRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCasePut(_response);
        });
    }

    protected processCasePut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caseDelete(body?: DeleteCaseRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseDelete(_response);
        });
    }

    protected processCaseDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignCase(body?: AssignCaseRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Case/AssignCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignCase(_response);
        });
    }

    protected processAssignCase(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    byCaseWorkerId(  cancelToken?: CancelToken | undefined): Promise<CaseResponse[]> {
        let url_ = this.baseUrl + "/api/Case/byCaseWorkerId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processByCaseWorkerId(_response);
        });
    }

    protected processByCaseWorkerId(response: AxiosResponse): Promise<CaseResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    byId(id: string | null , cancelToken?: CancelToken | undefined): Promise<CaseResponse> {
        let url_ = this.baseUrl + "/api/Case/byId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processById(_response);
        });
    }

    protected processById(response: AxiosResponse): Promise<CaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseResponse.fromJS(resultData200);
            return Promise.resolve<CaseResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDeletedCases(  cancelToken?: CancelToken | undefined): Promise<GetAllDeletedCasesResponse[]> {
        let url_ = this.baseUrl + "/api/Case/getDeletedCases";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeletedCases(_response);
        });
    }

    protected processGetDeletedCases(response: AxiosResponse): Promise<GetAllDeletedCasesResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllDeletedCasesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllDeletedCasesResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllDeletedCasesResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    hasCaseWorker(id: string , cancelToken?: CancelToken | undefined): Promise<HasCaseWorkerResponse> {
        let url_ = this.baseUrl + "/api/Case/hasCaseWorker/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasCaseWorker(_response);
        });
    }

    protected processHasCaseWorker(response: AxiosResponse): Promise<HasCaseWorkerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HasCaseWorkerResponse.fromJS(resultData200);
            return Promise.resolve<HasCaseWorkerResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HasCaseWorkerResponse>(null as any);
    }
}

export class CaseEntryClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    byId(id: string , cancelToken?: CancelToken | undefined): Promise<CaseEntryResponse[]> {
        let url_ = this.baseUrl + "/api/CaseEntry/byId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processById(_response);
        });
    }

    protected processById(response: AxiosResponse): Promise<CaseEntryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseEntryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseEntryResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseEntryResponse[]>(null as any);
    }
}

export class CaseEntryCommentClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caseEntryComment(body?: CreateCaseEntryCommentRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseEntryComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseEntryComment(_response);
        });
    }

    protected processCaseEntryComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    comment(id: string , cancelToken?: CancelToken | undefined): Promise<CaseEntryCommentResponse[]> {
        let url_ = this.baseUrl + "/api/CaseEntryComment/comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComment(_response);
        });
    }

    protected processComment(response: AxiosResponse): Promise<CaseEntryCommentResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseEntryCommentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseEntryCommentResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseEntryCommentResponse[]>(null as any);
    }
}

export class CaseEntryFileClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    file(id: string , cancelToken?: CancelToken | undefined): Promise<CaseEntryFileResponse[]> {
        let url_ = this.baseUrl + "/api/CaseEntryFile/file/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFile(_response);
        });
    }

    protected processFile(response: AxiosResponse): Promise<CaseEntryFileResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseEntryFileResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseEntryFileResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseEntryFileResponse[]>(null as any);
    }
}

export class CaseEntryNoteClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caseEntryNote(body?: CreateCaseEntryNoteRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseEntryNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseEntryNote(_response);
        });
    }

    protected processCaseEntryNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    note(id: string , cancelToken?: CancelToken | undefined): Promise<CaseEntryNoteResponse[]> {
        let url_ = this.baseUrl + "/api/CaseEntryNote/note/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNote(_response);
        });
    }

    protected processNote(response: AxiosResponse): Promise<CaseEntryNoteResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseEntryNoteResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseEntryNoteResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseEntryNoteResponse[]>(null as any);
    }
}

export class CaseEntryStatusClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caseEntryStatus(body?: CreateCaseEntryStatusRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseEntryStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseEntryStatus(_response);
        });
    }

    protected processCaseEntryStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    id(id?: string | undefined , cancelToken?: CancelToken | undefined): Promise<CaseEntryStatusResponse[]> {
        let url_ = this.baseUrl + "/api/CaseEntryStatus/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processId(_response);
        });
    }

    protected processId(response: AxiosResponse): Promise<CaseEntryStatusResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseEntryStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseEntryStatusResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseEntryStatusResponse[]>(null as any);
    }
}

export class CaseEntryTagClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    caseEntryTagGet(  cancelToken?: CancelToken | undefined): Promise<CaseEntryTagResponse[]> {
        let url_ = this.baseUrl + "/api/CaseEntryTag";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseEntryTagGet(_response);
        });
    }

    protected processCaseEntryTagGet(response: AxiosResponse): Promise<CaseEntryTagResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseEntryTagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseEntryTagResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseEntryTagResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caseEntryTagDelete(body?: DeleteCaseEntryTagRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseEntryTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseEntryTagDelete(_response);
        });
    }

    protected processCaseEntryTagDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caseEntryTagPost(body?: CreateCaseEntryTagsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseEntryTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseEntryTagPost(_response);
        });
    }

    protected processCaseEntryTagPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    new(  cancelToken?: CancelToken | undefined): Promise<CaseEntryTagResponse[]> {
        let url_ = this.baseUrl + "/api/CaseEntryTag/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNew(_response);
        });
    }

    protected processNew(response: AxiosResponse): Promise<CaseEntryTagResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseEntryTagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseEntryTagResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseEntryTagResponse[]>(null as any);
    }
}

export class ContactClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    caseUpdateByAdministratorEmail(body?: SendCaseUpdateByAdministratorEmailCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contact/caseUpdateByAdministratorEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaseUpdateByAdministratorEmail(_response);
        });
    }

    protected processCaseUpdateByAdministratorEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInformationEmail(body?: SendInformationEmailCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contact/sendInformationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendInformationEmail(_response);
        });
    }

    protected processSendInformationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DocumentClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    document(organisationId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Document/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument(_response);
        });
    }

    protected processDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class OrganisationClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    organisationGet(  cancelToken?: CancelToken | undefined): Promise<OrganisationResponse[]> {
        let url_ = this.baseUrl + "/api/Organisation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisationGet(_response);
        });
    }

    protected processOrganisationGet(response: AxiosResponse): Promise<OrganisationResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganisationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrganisationResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    organisationPost(body?: CreateOrganisationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisationPost(_response);
        });
    }

    protected processOrganisationPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    byId(id: string , cancelToken?: CancelToken | undefined): Promise<OrganisationResponse> {
        let url_ = this.baseUrl + "/api/Organisation/byId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processById(_response);
        });
    }

    protected processById(response: AxiosResponse): Promise<OrganisationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganisationResponse.fromJS(resultData200);
            return Promise.resolve<OrganisationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationResponse>(null as any);
    }

    /**
     * @return Success
     */
    changeOrganisation(organisationId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organisation/change-organisation/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeOrganisation(_response);
        });
    }

    protected processChangeOrganisation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNewTinNumber(body?: CreateNewTinNumberRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organisation/CreateNewTinNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewTinNumber(_response);
        });
    }

    protected processCreateNewTinNumber(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteOrganisation(body?: DeleteOrganisationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organisation/deleteOrganisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrganisation(_response);
        });
    }

    protected processDeleteOrganisation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadCompanyLogo(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Organisation/downloadCompanyLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCompanyLogo(_response);
        });
    }

    protected processDownloadCompanyLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @param file (optional) 
     * @return Success
     */
    upload(body?: Body | undefined, file?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organisation/file/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    hasCompanyLogo(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Organisation/HasCompanyLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasCompanyLogo(_response);
        });
    }

    protected processHasCompanyLogo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    document(organisationId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Organisation/organisation/byTinNumber/{organisationId}/document";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument(_response);
        });
    }

    protected processDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    tinNumber(tinNumber: string | null , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Organisation/tin-number/{tinNumber}";
        if (tinNumber === undefined || tinNumber === null)
            throw new Error("The parameter 'tinNumber' must be defined.");
        url_ = url_.replace("{tinNumber}", encodeURIComponent("" + tinNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTinNumber(_response);
        });
    }

    protected processTinNumber(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class PartnerClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    partnerGet(  cancelToken?: CancelToken | undefined): Promise<PartnerResponse[]> {
        let url_ = this.baseUrl + "/api/Partner";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerGet(_response);
        });
    }

    protected processPartnerGet(response: AxiosResponse): Promise<PartnerResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PartnerResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerPost(body?: CreatePartnerRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerPost(_response);
        });
    }

    protected processPartnerPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    changePartner(partnerId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Partner/change-partner/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePartner(_response);
        });
    }

    protected processChangePartner(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    organisations(  cancelToken?: CancelToken | undefined): Promise<OrganisationResponse[]> {
        let url_ = this.baseUrl + "/api/Partner/organisations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisations(_response);
        });
    }

    protected processOrganisations(response: AxiosResponse): Promise<OrganisationResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganisationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrganisationResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    subPartners(  cancelToken?: CancelToken | undefined): Promise<PartnerResponse[]> {
        let url_ = this.baseUrl + "/api/Partner/sub-partners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubPartners(_response);
        });
    }

    protected processSubPartners(response: AxiosResponse): Promise<PartnerResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PartnerResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    tinNumber(tinNumber: string | null , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Partner/tin-number/{tinNumber}";
        if (tinNumber === undefined || tinNumber === null)
            throw new Error("The parameter 'tinNumber' must be defined.");
        url_ = url_.replace("{tinNumber}", encodeURIComponent("" + tinNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTinNumber(_response);
        });
    }

    protected processTinNumber(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class StatusClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    new(  cancelToken?: CancelToken | undefined): Promise<StatusResponse[]> {
        let url_ = this.baseUrl + "/api/Status/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNew(_response);
        });
    }

    protected processNew(response: AxiosResponse): Promise<StatusResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StatusResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResponse[]>(null as any);
    }
}

export class TagClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tag(body?: CreateTagsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CreateTagResponse[]> {
        let url_ = this.baseUrl + "/api/Tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTag(_response);
        });
    }

    protected processTag(response: AxiosResponse): Promise<CreateTagResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateTagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CreateTagResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTagResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    case(caseId: string , cancelToken?: CancelToken | undefined): Promise<TagResponse[]> {
        let url_ = this.baseUrl + "/api/Tag/case/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCase(_response);
        });
    }

    protected processCase(response: AxiosResponse): Promise<TagResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    organisation(  cancelToken?: CancelToken | undefined): Promise<TagResponse[]> {
        let url_ = this.baseUrl + "/api/Tag/organisation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation(_response);
        });
    }

    protected processOrganisation(response: AxiosResponse): Promise<TagResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponse[]>(null as any);
    }
}

export class UpdateUserRequest implements IUpdateUserRequest {
    email?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateUserRequest {
    email?: string | undefined;
    name?: string | undefined;
}

export class GetAllUsersResponse implements IGetAllUsersResponse {
    userId?: string;
    organisationName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    createdOn?: Date;

    constructor(data?: IGetAllUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organisationName = _data["organisationName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organisationName"] = this.organisationName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["role"] = this.role;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllUsersResponse {
    userId?: string;
    organisationName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    createdOn?: Date;
}

export enum Status {
    _5 = 5,
    _10 = 10,
    _20 = 20,
    _30 = 30,
    _40 = 40,
}

export class CaseResponseUser implements ICaseResponseUser {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICaseResponseUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CaseResponseUser {
        data = typeof data === 'object' ? data : {};
        let result = new CaseResponseUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface ICaseResponseUser {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
}

export class CaseResponse implements ICaseResponse {
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: Status;
    detectedLanguage?: string | undefined;
    translatedLanguage?: string | undefined;
    translatedTitle?: string | undefined;
    translatedDescription?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    users?: CaseResponseUser[] | undefined;

    constructor(data?: ICaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.detectedLanguage = _data["detectedLanguage"];
            this.translatedLanguage = _data["translatedLanguage"];
            this.translatedTitle = _data["translatedTitle"];
            this.translatedDescription = _data["translatedDescription"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(CaseResponseUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["detectedLanguage"] = this.detectedLanguage;
        data["translatedLanguage"] = this.translatedLanguage;
        data["translatedTitle"] = this.translatedTitle;
        data["translatedDescription"] = this.translatedDescription;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaseResponse {
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: Status;
    detectedLanguage?: string | undefined;
    translatedLanguage?: string | undefined;
    translatedTitle?: string | undefined;
    translatedDescription?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    users?: CaseResponseUser[] | undefined;
}

export class CreateCaseRequest implements ICreateCaseRequest {
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: Status;
    detectedLanguage?: string | undefined;
    translatedLanguage?: string | undefined;
    translatedTitle?: string | undefined;
    translatedDescription?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    users?: CaseResponseUser[] | undefined;

    constructor(data?: ICreateCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.detectedLanguage = _data["detectedLanguage"];
            this.translatedLanguage = _data["translatedLanguage"];
            this.translatedTitle = _data["translatedTitle"];
            this.translatedDescription = _data["translatedDescription"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(CaseResponseUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["detectedLanguage"] = this.detectedLanguage;
        data["translatedLanguage"] = this.translatedLanguage;
        data["translatedTitle"] = this.translatedTitle;
        data["translatedDescription"] = this.translatedDescription;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCaseRequest {
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: Status;
    detectedLanguage?: string | undefined;
    translatedLanguage?: string | undefined;
    translatedTitle?: string | undefined;
    translatedDescription?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    users?: CaseResponseUser[] | undefined;
}

export class UpdateCaseRequest implements IUpdateCaseRequest {
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: Status;
    detectedLanguage?: string | undefined;
    translatedLanguage?: string | undefined;
    translatedTitle?: string | undefined;
    translatedDescription?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    users?: CaseResponseUser[] | undefined;

    constructor(data?: IUpdateCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.detectedLanguage = _data["detectedLanguage"];
            this.translatedLanguage = _data["translatedLanguage"];
            this.translatedTitle = _data["translatedTitle"];
            this.translatedDescription = _data["translatedDescription"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(CaseResponseUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["detectedLanguage"] = this.detectedLanguage;
        data["translatedLanguage"] = this.translatedLanguage;
        data["translatedTitle"] = this.translatedTitle;
        data["translatedDescription"] = this.translatedDescription;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateCaseRequest {
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: Status;
    detectedLanguage?: string | undefined;
    translatedLanguage?: string | undefined;
    translatedTitle?: string | undefined;
    translatedDescription?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    users?: CaseResponseUser[] | undefined;
}

export class DeleteCaseRequest implements IDeleteCaseRequest {
    id?: string;

    constructor(data?: IDeleteCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteCaseRequest {
    id?: string;
}

export class AssignCaseRequest implements IAssignCaseRequest {
    caseId?: string;
    caseWorkerEmails?: string[] | undefined;

    constructor(data?: IAssignCaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["caseWorkerEmails"])) {
                this.caseWorkerEmails = [] as any;
                for (let item of _data["caseWorkerEmails"])
                    this.caseWorkerEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): AssignCaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.caseWorkerEmails)) {
            data["caseWorkerEmails"] = [];
            for (let item of this.caseWorkerEmails)
                data["caseWorkerEmails"].push(item);
        }
        return data;
    }
}

export interface IAssignCaseRequest {
    caseId?: string;
    caseWorkerEmails?: string[] | undefined;
}

export class GetAllDeletedCasesResponse implements IGetAllDeletedCasesResponse {
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    email?: string | undefined;

    constructor(data?: IGetAllDeletedCasesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetAllDeletedCasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDeletedCasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["email"] = this.email;
        return data;
    }
}

export interface IGetAllDeletedCasesResponse {
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    email?: string | undefined;
}

export class HasCaseWorkerResponse implements IHasCaseWorkerResponse {
    hasCaseWorker?: boolean;

    constructor(data?: IHasCaseWorkerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasCaseWorker = _data["hasCaseWorker"];
        }
    }

    static fromJS(data: any): HasCaseWorkerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HasCaseWorkerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasCaseWorker"] = this.hasCaseWorker;
        return data;
    }
}

export interface IHasCaseWorkerResponse {
    hasCaseWorker?: boolean;
}

export class CaseEntryResponse implements ICaseEntryResponse {
    id?: string;
    caseId?: string;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date;
    modifiedBy?: string;
    entryType?: string | undefined;
    comment?: string | undefined;
    fileId?: string;
    note?: string | undefined;
    tagId?: string;
    tagTitle?: string | undefined;
    status?: Status;

    constructor(data?: ICaseEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.entryType = _data["entryType"];
            this.comment = _data["comment"];
            this.fileId = _data["fileId"];
            this.note = _data["note"];
            this.tagId = _data["tagId"];
            this.tagTitle = _data["tagTitle"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CaseEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["entryType"] = this.entryType;
        data["comment"] = this.comment;
        data["fileId"] = this.fileId;
        data["note"] = this.note;
        data["tagId"] = this.tagId;
        data["tagTitle"] = this.tagTitle;
        data["status"] = this.status;
        return data;
    }
}

export interface ICaseEntryResponse {
    id?: string;
    caseId?: string;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date;
    modifiedBy?: string;
    entryType?: string | undefined;
    comment?: string | undefined;
    fileId?: string;
    note?: string | undefined;
    tagId?: string;
    tagTitle?: string | undefined;
    status?: Status;
}

export class Sentence implements ISentence {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    sentenceText?: string | undefined;
    sentenceSentiment?: string | undefined;
    sentenceNegativeScore?: number;
    sentenceNeutralScore?: number;
    sentencePositiveScore?: number;
    sentimentId?: string;
    sentiment?: Sentiment;

    constructor(data?: ISentence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.sentenceText = _data["sentenceText"];
            this.sentenceSentiment = _data["sentenceSentiment"];
            this.sentenceNegativeScore = _data["sentenceNegativeScore"];
            this.sentenceNeutralScore = _data["sentenceNeutralScore"];
            this.sentencePositiveScore = _data["sentencePositiveScore"];
            this.sentimentId = _data["sentimentId"];
            this.sentiment = _data["sentiment"] ? Sentiment.fromJS(_data["sentiment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Sentence {
        data = typeof data === 'object' ? data : {};
        let result = new Sentence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["sentenceText"] = this.sentenceText;
        data["sentenceSentiment"] = this.sentenceSentiment;
        data["sentenceNegativeScore"] = this.sentenceNegativeScore;
        data["sentenceNeutralScore"] = this.sentenceNeutralScore;
        data["sentencePositiveScore"] = this.sentencePositiveScore;
        data["sentimentId"] = this.sentimentId;
        data["sentiment"] = this.sentiment ? this.sentiment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISentence {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    sentenceText?: string | undefined;
    sentenceSentiment?: string | undefined;
    sentenceNegativeScore?: number;
    sentenceNeutralScore?: number;
    sentencePositiveScore?: number;
    sentimentId?: string;
    sentiment?: Sentiment;
}

export class Sentiment implements ISentiment {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    documentSentiment?: string | undefined;
    documentNegativeScore?: number;
    documentNeutralScore?: number;
    documentPositiveScore?: number;
    caseId?: string;
    case?: Case;
    sentences?: Sentence[] | undefined;

    constructor(data?: ISentiment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.documentSentiment = _data["documentSentiment"];
            this.documentNegativeScore = _data["documentNegativeScore"];
            this.documentNeutralScore = _data["documentNeutralScore"];
            this.documentPositiveScore = _data["documentPositiveScore"];
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            if (Array.isArray(_data["sentences"])) {
                this.sentences = [] as any;
                for (let item of _data["sentences"])
                    this.sentences!.push(Sentence.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Sentiment {
        data = typeof data === 'object' ? data : {};
        let result = new Sentiment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["documentSentiment"] = this.documentSentiment;
        data["documentNegativeScore"] = this.documentNegativeScore;
        data["documentNeutralScore"] = this.documentNeutralScore;
        data["documentPositiveScore"] = this.documentPositiveScore;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        if (Array.isArray(this.sentences)) {
            data["sentences"] = [];
            for (let item of this.sentences)
                data["sentences"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISentiment {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    documentSentiment?: string | undefined;
    documentNegativeScore?: number;
    documentNeutralScore?: number;
    documentPositiveScore?: number;
    caseId?: string;
    case?: Case;
    sentences?: Sentence[] | undefined;
}

export class BaseCaseEntry implements IBaseCaseEntry {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string;
    case?: Case;

    constructor(data?: IBaseCaseEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseCaseEntry {
        data = typeof data === 'object' ? data : {};
        let result = new BaseCaseEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseCaseEntry {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string;
    case?: Case;
}

export class Role implements IRole {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    id?: string;
    name?: string | undefined;
    users?: User[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRole {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    id?: string;
    name?: string | undefined;
    users?: User[] | undefined;
}

export class UserOrganisation implements IUserOrganisation {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    userId?: string;
    user?: User;
    roleId?: string;
    role?: Role;

    constructor(data?: IUserOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserOrganisation {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserOrganisation {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    userId?: string;
    user?: User;
    roleId?: string;
    role?: Role;
}

export class UserPartner implements IUserPartner {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    partnerId?: string;
    userId?: string;
    user?: User;
    roleId?: string;
    role?: Role;

    constructor(data?: IUserPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.partnerId = _data["partnerId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserPartner {
        data = typeof data === 'object' ? data : {};
        let result = new UserPartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["partnerId"] = this.partnerId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserPartner {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    partnerId?: string;
    userId?: string;
    user?: User;
    roleId?: string;
    role?: Role;
}

export class User implements IUser {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    id?: string;
    externalId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    organisations?: UserOrganisation[] | undefined;
    partners?: UserPartner[] | undefined;
    cases?: CaseUser[] | undefined;
    currentOrganisationId?: string;
    currentPartnerId?: string;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.email = _data["email"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(UserOrganisation.fromJS(item));
            }
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(UserPartner.fromJS(item));
            }
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(CaseUser.fromJS(item));
            }
            this.currentOrganisationId = _data["currentOrganisationId"];
            this.currentPartnerId = _data["currentPartnerId"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["email"] = this.email;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        data["currentOrganisationId"] = this.currentOrganisationId;
        data["currentPartnerId"] = this.currentPartnerId;
        return data;
    }
}

export interface IUser {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    id?: string;
    externalId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    organisations?: UserOrganisation[] | undefined;
    partners?: UserPartner[] | undefined;
    cases?: CaseUser[] | undefined;
    currentOrganisationId?: string;
    currentPartnerId?: string;
}

export class CaseUser implements ICaseUser {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    userId?: string;
    user?: User;
    caseId?: string;
    case?: Case;

    constructor(data?: ICaseUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseUser {
        data = typeof data === 'object' ? data : {};
        let result = new CaseUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseUser {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    userId?: string;
    user?: User;
    caseId?: string;
    case?: Case;
}

export class Case implements ICase {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: Status;
    detectedLanguage?: string | undefined;
    translatedLanguage?: string | undefined;
    translatedTitle?: string | undefined;
    translatedDescription?: string | undefined;
    sentimentId?: string;
    sentiment?: Sentiment;
    caseEntries?: BaseCaseEntry[] | undefined;
    users?: CaseUser[] | undefined;

    constructor(data?: ICase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.detectedLanguage = _data["detectedLanguage"];
            this.translatedLanguage = _data["translatedLanguage"];
            this.translatedTitle = _data["translatedTitle"];
            this.translatedDescription = _data["translatedDescription"];
            this.sentimentId = _data["sentimentId"];
            this.sentiment = _data["sentiment"] ? Sentiment.fromJS(_data["sentiment"]) : <any>undefined;
            if (Array.isArray(_data["caseEntries"])) {
                this.caseEntries = [] as any;
                for (let item of _data["caseEntries"])
                    this.caseEntries!.push(BaseCaseEntry.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(CaseUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Case {
        data = typeof data === 'object' ? data : {};
        let result = new Case();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["detectedLanguage"] = this.detectedLanguage;
        data["translatedLanguage"] = this.translatedLanguage;
        data["translatedTitle"] = this.translatedTitle;
        data["translatedDescription"] = this.translatedDescription;
        data["sentimentId"] = this.sentimentId;
        data["sentiment"] = this.sentiment ? this.sentiment.toJSON() : <any>undefined;
        if (Array.isArray(this.caseEntries)) {
            data["caseEntries"] = [];
            for (let item of this.caseEntries)
                data["caseEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICase {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: Status;
    detectedLanguage?: string | undefined;
    translatedLanguage?: string | undefined;
    translatedTitle?: string | undefined;
    translatedDescription?: string | undefined;
    sentimentId?: string;
    sentiment?: Sentiment;
    caseEntries?: BaseCaseEntry[] | undefined;
    users?: CaseUser[] | undefined;
}

export class CreateCaseEntryCommentRequest implements ICreateCaseEntryCommentRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    caseId?: string;
    case?: Case;
    comment?: string | undefined;
    id?: string;

    constructor(data?: ICreateCaseEntryCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCaseEntryCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseEntryCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateCaseEntryCommentRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    caseId?: string;
    case?: Case;
    comment?: string | undefined;
    id?: string;
}

export class CaseEntryCommentResponse implements ICaseEntryCommentResponse {
    id?: string;
    caseId?: string;
    createdBy?: string | undefined;
    createdOn?: Date;
    comment?: string | undefined;

    constructor(data?: ICaseEntryCommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CaseEntryCommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseEntryCommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICaseEntryCommentResponse {
    id?: string;
    caseId?: string;
    createdBy?: string | undefined;
    createdOn?: Date;
    comment?: string | undefined;
}

export class CaseEntryFileResponse implements ICaseEntryFileResponse {
    id?: string;
    caseId?: string;
    createdBy?: string | undefined;
    createdOn?: Date;
    fileId?: string;

    constructor(data?: ICaseEntryFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): CaseEntryFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseEntryFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface ICaseEntryFileResponse {
    id?: string;
    caseId?: string;
    createdBy?: string | undefined;
    createdOn?: Date;
    fileId?: string;
}

export class CreateCaseEntryNoteRequest implements ICreateCaseEntryNoteRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    caseId?: string;
    case?: Case;
    note?: string | undefined;
    id?: string;

    constructor(data?: ICreateCaseEntryNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            this.note = _data["note"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCaseEntryNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseEntryNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["note"] = this.note;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateCaseEntryNoteRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    caseId?: string;
    case?: Case;
    note?: string | undefined;
    id?: string;
}

export class CaseEntryNoteResponse implements ICaseEntryNoteResponse {
    id?: string;
    caseId?: string;
    createdBy?: string | undefined;
    createdOn?: Date;
    note?: string | undefined;

    constructor(data?: ICaseEntryNoteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CaseEntryNoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseEntryNoteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }
}

export interface ICaseEntryNoteResponse {
    id?: string;
    caseId?: string;
    createdBy?: string | undefined;
    createdOn?: Date;
    note?: string | undefined;
}

export class CreateCaseEntryStatusRequest implements ICreateCaseEntryStatusRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    caseId?: string;
    case?: Case;
    status?: Status;
    id?: string;

    constructor(data?: ICreateCaseEntryStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCaseEntryStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseEntryStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateCaseEntryStatusRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    caseId?: string;
    case?: Case;
    status?: Status;
    id?: string;
}

export class CaseEntryStatusResponse implements ICaseEntryStatusResponse {
    id?: string;

    constructor(data?: ICaseEntryStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CaseEntryStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseEntryStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICaseEntryStatusResponse {
    id?: string;
}

export class CaseEntryTagResponse implements ICaseEntryTagResponse {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    caseId?: string;
    title?: string | undefined;

    constructor(data?: ICaseEntryTagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.caseId = _data["caseId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CaseEntryTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseEntryTagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        return data;
    }
}

export interface ICaseEntryTagResponse {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    caseId?: string;
    title?: string | undefined;
}

export class CaseEntryTag implements ICaseEntryTag {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string;
    case?: Case;
    tagId?: string;
    tag?: Tag;

    constructor(data?: ICaseEntryTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseEntryTag {
        data = typeof data === 'object' ? data : {};
        let result = new CaseEntryTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseEntryTag {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string;
    case?: Case;
    tagId?: string;
    tag?: Tag;
}

export class Tag implements ITag {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    title?: string | undefined;
    caseEntries?: CaseEntryTag[] | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["caseEntries"])) {
                this.caseEntries = [] as any;
                for (let item of _data["caseEntries"])
                    this.caseEntries!.push(CaseEntryTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.caseEntries)) {
            data["caseEntries"] = [];
            for (let item of this.caseEntries)
                data["caseEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITag {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    title?: string | undefined;
    caseEntries?: CaseEntryTag[] | undefined;
}

export class DeleteCaseEntryTagRequest implements IDeleteCaseEntryTagRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string;
    case?: Case;
    tagId?: string;
    tag?: Tag;

    constructor(data?: IDeleteCaseEntryTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteCaseEntryTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCaseEntryTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteCaseEntryTagRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string;
    case?: Case;
    tagId?: string;
    tag?: Tag;
}

export class CreateCaseEntryTagRequest implements ICreateCaseEntryTagRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string;
    case?: Case;
    tagId?: string;
    tag?: Tag;

    constructor(data?: ICreateCaseEntryTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCaseEntryTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseEntryTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCaseEntryTagRequest {
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date | undefined;
    deletedBy?: string;
    deletedOn?: Date | undefined;
    organisationId?: string;
    id?: string;
    caseId?: string;
    case?: Case;
    tagId?: string;
    tag?: Tag;
}

export class CreateCaseEntryTagsRequest implements ICreateCaseEntryTagsRequest {
    tags?: CreateCaseEntryTagRequest[] | undefined;

    constructor(data?: ICreateCaseEntryTagsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(CreateCaseEntryTagRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCaseEntryTagsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseEntryTagsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCaseEntryTagsRequest {
    tags?: CreateCaseEntryTagRequest[] | undefined;
}

export class SendCaseUpdateByAdministratorEmailCommand implements ISendCaseUpdateByAdministratorEmailCommand {
    id?: string;
    caseId?: string | undefined;

    constructor(data?: ISendCaseUpdateByAdministratorEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): SendCaseUpdateByAdministratorEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendCaseUpdateByAdministratorEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ISendCaseUpdateByAdministratorEmailCommand {
    id?: string;
    caseId?: string | undefined;
}

export class SendInformationEmailCommand implements ISendInformationEmailCommand {
    id?: string;
    receivingEmail?: string | undefined;
    emailBody?: string | undefined;

    constructor(data?: ISendInformationEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receivingEmail = _data["receivingEmail"];
            this.emailBody = _data["emailBody"];
        }
    }

    static fromJS(data: any): SendInformationEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendInformationEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receivingEmail"] = this.receivingEmail;
        data["emailBody"] = this.emailBody;
        return data;
    }
}

export interface ISendInformationEmailCommand {
    id?: string;
    receivingEmail?: string | undefined;
    emailBody?: string | undefined;
}

export class OrganisationResponse implements IOrganisationResponse {
    id?: string;
    name?: string | undefined;
    tinNumber?: string | undefined;
    selected?: boolean;

    constructor(data?: IOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.tinNumber = _data["tinNumber"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): OrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tinNumber"] = this.tinNumber;
        data["selected"] = this.selected;
        return data;
    }
}

export interface IOrganisationResponse {
    id?: string;
    name?: string | undefined;
    tinNumber?: string | undefined;
    selected?: boolean;
}

export class CreateOrganisationRequest implements ICreateOrganisationRequest {
    name?: string | undefined;
    country?: string | undefined;
    tinNumber?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    ownerEmail?: string | undefined;

    constructor(data?: ICreateOrganisationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.country = _data["country"];
            this.tinNumber = _data["tinNumber"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.ownerEmail = _data["ownerEmail"];
        }
    }

    static fromJS(data: any): CreateOrganisationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganisationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["country"] = this.country;
        data["tinNumber"] = this.tinNumber;
        data["address"] = this.address;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["ownerEmail"] = this.ownerEmail;
        return data;
    }
}

export interface ICreateOrganisationRequest {
    name?: string | undefined;
    country?: string | undefined;
    tinNumber?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    ownerEmail?: string | undefined;
}

export class CreateNewTinNumberRequest implements ICreateNewTinNumberRequest {
    displayName?: string | undefined;
    tinNumber?: string | undefined;

    constructor(data?: ICreateNewTinNumberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.tinNumber = _data["tinNumber"];
        }
    }

    static fromJS(data: any): CreateNewTinNumberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewTinNumberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["tinNumber"] = this.tinNumber;
        return data;
    }
}

export interface ICreateNewTinNumberRequest {
    displayName?: string | undefined;
    tinNumber?: string | undefined;
}

export class DeleteOrganisationRequest implements IDeleteOrganisationRequest {
    organisationId?: string;

    constructor(data?: IDeleteOrganisationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
        }
    }

    static fromJS(data: any): DeleteOrganisationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrganisationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        return data;
    }
}

export interface IDeleteOrganisationRequest {
    organisationId?: string;
}

export class PartnerResponse implements IPartnerResponse {
    id?: string;
    name?: string | undefined;
    tinNumber?: string | undefined;
    email?: string | undefined;
    selected?: boolean;

    constructor(data?: IPartnerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.tinNumber = _data["tinNumber"];
            this.email = _data["email"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): PartnerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tinNumber"] = this.tinNumber;
        data["email"] = this.email;
        data["selected"] = this.selected;
        return data;
    }
}

export interface IPartnerResponse {
    id?: string;
    name?: string | undefined;
    tinNumber?: string | undefined;
    email?: string | undefined;
    selected?: boolean;
}

export class CreatePartnerRequest implements ICreatePartnerRequest {
    name?: string | undefined;
    tinNumber?: string | undefined;
    partnerEmail?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ICreatePartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.tinNumber = _data["tinNumber"];
            this.partnerEmail = _data["partnerEmail"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): CreatePartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tinNumber"] = this.tinNumber;
        data["partnerEmail"] = this.partnerEmail;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ICreatePartnerRequest {
    name?: string | undefined;
    tinNumber?: string | undefined;
    partnerEmail?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
}

export class StatusResponse implements IStatusResponse {
    status?: Status;

    constructor(data?: IStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IStatusResponse {
    status?: Status;
}

export class CreateTagsRequest implements ICreateTagsRequest {
    tagTitles?: string[] | undefined;

    constructor(data?: ICreateTagsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tagTitles"])) {
                this.tagTitles = [] as any;
                for (let item of _data["tagTitles"])
                    this.tagTitles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTagsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tagTitles)) {
            data["tagTitles"] = [];
            for (let item of this.tagTitles)
                data["tagTitles"].push(item);
        }
        return data;
    }
}

export interface ICreateTagsRequest {
    tagTitles?: string[] | undefined;
}

export class CreateTagResponse implements ICreateTagResponse {
    id?: string;
    caseId?: string;
    tagTitle?: string | undefined;
    tagId?: string;
    modifiedOn?: Date;

    constructor(data?: ICreateTagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.tagTitle = _data["tagTitle"];
            this.tagId = _data["tagId"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["tagTitle"] = this.tagTitle;
        data["tagId"] = this.tagId;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateTagResponse {
    id?: string;
    caseId?: string;
    tagTitle?: string | undefined;
    tagId?: string;
    modifiedOn?: Date;
}

export class TagResponse implements ITagResponse {
    id?: string;
    caseId?: string;
    tagTitle?: string | undefined;
    tagId?: string;
    modifiedOn?: Date;

    constructor(data?: ITagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.tagTitle = _data["tagTitle"];
            this.tagId = _data["tagId"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["tagTitle"] = this.tagTitle;
        data["tagId"] = this.tagId;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITagResponse {
    id?: string;
    caseId?: string;
    tagTitle?: string | undefined;
    tagId?: string;
    modifiedOn?: Date;
}

export class DeleteUserRequest implements IDeleteUserRequest {
    id?: string;

    constructor(data?: IDeleteUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteUserRequest {
    id?: string;
}

export class GetCurrentUserResponse implements IGetCurrentUserResponse {
    id?: string;
    isAdmin?: boolean;

    constructor(data?: IGetCurrentUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): GetCurrentUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IGetCurrentUserResponse {
    id?: string;
    isAdmin?: boolean;
}

export class GetCurrentUserRoleResponse implements IGetCurrentUserRoleResponse {
    isLegalTechPartner?: boolean;

    constructor(data?: IGetCurrentUserRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLegalTechPartner = _data["isLegalTechPartner"];
        }
    }

    static fromJS(data: any): GetCurrentUserRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentUserRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLegalTechPartner"] = this.isLegalTechPartner;
        return data;
    }
}

export interface IGetCurrentUserRoleResponse {
    isLegalTechPartner?: boolean;
}

export class UserResponse implements IUserResponse {
    email?: string | undefined;
    name?: string | undefined;
    organisationAdministrator?: boolean;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.organisationAdministrator = _data["organisationAdministrator"];
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["organisationAdministrator"] = this.organisationAdministrator;
        return data;
    }
}

export interface IUserResponse {
    email?: string | undefined;
    name?: string | undefined;
    organisationAdministrator?: boolean;
}

export class UserRoleResponse implements IUserRoleResponse {
    id?: string;
    email?: string | undefined;
    name?: string | undefined;
    roleId?: string;
    organisationAdministrator?: boolean;

    constructor(data?: IUserRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.roleId = _data["roleId"];
            this.organisationAdministrator = _data["organisationAdministrator"];
        }
    }

    static fromJS(data: any): UserRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["roleId"] = this.roleId;
        data["organisationAdministrator"] = this.organisationAdministrator;
        return data;
    }
}

export interface IUserRoleResponse {
    id?: string;
    email?: string | undefined;
    name?: string | undefined;
    roleId?: string;
    organisationAdministrator?: boolean;
}

export class UpdateUserNameRequest implements IUpdateUserNameRequest {
    id?: string;
    name?: string | undefined;

    constructor(data?: IUpdateUserNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateUserNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateUserNameRequest {
    id?: string;
    name?: string | undefined;
}

export class Body implements IBody {
    file?: string | undefined;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["File"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["File"] = this.file;
        return data;
    }
}

export interface IBody {
    file?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}